import apiClient from '../utils/apiClient';

// Get all internal contacts (employees)
export async function getInternalContacts() {
  const response = await apiClient.get('/api/directory/internal');
  return response.data;
}

// Get all external contacts (grouped by company)
export async function getExternalContacts() {
  const response = await apiClient.get('/api/directory/external');
  return response.data;
}

// ========== COMPANY FUNCTIONS ==========

// Create external company (with optional initial contact)
export async function createExternalCompany(companyData) {
  const response = await apiClient.post('/api/directory/external/companies', companyData);
  return response.data;
}

// Update external company
export async function updateExternalCompany(clientCompanyId, companyData) {
  const response = await apiClient.put(`/api/directory/external/companies/${clientCompanyId}`, companyData);
  return response.data;
}
// Active projects and open leads for one company
export async function getCompanyWork(clientCompanyId) {
  const response = await apiClient.get(`/api/directory/external/companies/${clientCompanyId}/work`);
  return response.data;
}

// Set the industry on several companies; pass { restore } from a previous result to undo
export async function batchUpdateCompanies(body) {
  const response = await apiClient.patch('/api/directory/external/companies/batch', body);
  return response.data;
}

// Move several contacts to a company (client_company_id: null for none); pass { restore } to undo
export async function batchUpdateContacts(body) {
  const response = await apiClient.patch('/api/directory/external/contacts/batch', body);
  return response.data;
}

// Upload client company logo
export async function uploadClientCompanyLogo(clientCompanyId, logoFile) {
  const formData = new FormData();
  formData.append('logo', logoFile);
  
  const response = await apiClient.post(`/api/directory/external/companies/${clientCompanyId}/logo`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
}
// Delete external company (and all its contacts)
export async function deleteExternalCompany(clientCompanyId) {
  const response = await apiClient.delete(`/api/directory/external/companies/${clientCompanyId}`);
  return response.data;
}

// ========== CONTACT FUNCTIONS ==========

// Create contact under specific company
export async function createExternalContact(clientCompanyId, contactData) {
  const response = await apiClient.post(`/api/directory/external/companies/${clientCompanyId}/contacts`, contactData);
  return response.data;
}

// Create standalone contact (not associated with any company)
export async function createStandaloneContact(contactData) {
  const response = await apiClient.post('/api/directory/external/contacts', contactData);
  return response.data;
}

// Update external contact
export async function updateExternalContact(clientContactId, contactData) {
  const response = await apiClient.put(`/api/directory/external/contacts/${clientContactId}`, contactData);
  return response.data;
}

// Delete external contact
export async function deleteExternalContact(clientContactId) {
  const response = await apiClient.delete(`/api/directory/external/contacts/${clientContactId}`);
  return response.data;
}

// ========== EMPLOYEE FUNCTIONS ==========

// Update internal employee contact details
export async function updateInternalContact(userId, contactData) {
  const response = await apiClient.put(`/api/employees/${userId}`, contactData);
  return response.data;
}